<div class="inner-page-header py-5 text-white">
  <div class="container px-lg-5">
    <h1 class="display-5 fw-bold text-uppercase mb-2">College In News</h1>
    <p class="lead mb-0 text-orange-light">“Where Accomplishments Make Headlines”</p>
  </div>
</div>

<div class="container px-lg-5 py-5">
  <div class="row g-5 align-items-center">
    <div class="col-12 col-lg-8">
      <div class="content-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-success">
        <h3 class="fw-bold mb-4 text-success border-bottom pb-2">
          <i class="fa-solid fa-newspaper me-2"></i> Leading in Academics & Sports
        </h3>
        
        <p class="lead text-muted mb-0" style="line-height: 1.8; text-align: justify;">
          Shah Satnam Ji Girls College is continually making headlines with our outstanding achievements and vibrant activities. Our commitment to excellence is reflected in the numerous accolades and honours we receive across various domains. These achievements mark their presence in different News sections of different NEWSPAPERS.
        </p>
      </div>
    </div>

    <!-- Right Side Focus Card -->
    <div class="col-12 col-lg-4">
      <div class="focus-card p-4 shadow-lg rounded-4 text-white text-center d-flex flex-column justify-content-center" style="background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%); min-height: 250px;">
        <div class="news-icon mb-3"><i class="fa-solid fa-square-rss text-white"></i></div>
        <h4 class="fw-bold mb-1">Press Coverage</h4>
        <p class="text-orange-light small mb-0">Academic & athletic breakthroughs published across print media daily.</p>
      </div>
    </div>
  </div>

  <h3 class="fw-bold text-success mt-5 mb-4 text-uppercase">
    <i class="fa-solid fa-images me-2"></i> Newspaper Clippings Gallery
  </h3>

  <div class="row g-3">
    <div class="col-6 col-md-3" *ngFor="let img of newsImages">
      <div class="news-img-thumb rounded-4 overflow-hidden shadow-sm border border-2 border-white">
        <img [src]="img" alt="Press Coverage Clipping" class="img-fluid news-img">
      </div>
    </div>
  </div>
</div>
